export enum LeadAssignmentStatusEnum {
    PENDING = 'PENDING',
    ACCEPTED = 'ACCEPTED',
    PROCESSED = 'PROCESSED',
    INTERESTED = 'INTERESTED',
    PURCHASED = 'PURCHASED',
    REJECTED = 'REJECTED',
    SUSPENDED = 'SUSPENDED',
    ARCHIVED = 'ARCHIVED'
}